import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { groupSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/group';
import { getProfileOwner } from '../../selectors/users';
import { API_BASE_PATH } from '../../../server/routes/constants';
import { PapiGroupsRequestParams } from '../../../types/papi';

function fetchFromApi(params) {
  return axios
    .get(`${API_BASE_PATH}/module/groups/members`, { params })
    .catch(response => false);
}

export default function* fetchMoreGroupsMember(action) {
  const { streamId } = action;

  const [offset, limit, moduleId, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state =>
      streamSelectors.getStreamParam(state, streamId, 'moduleId')
    ),
    select(getProfileOwner),
  ]);

  const queryParams: PapiGroupsRequestParams = {
    username: profileOwner.user.username,
    moduleid: moduleId,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response && response.status === 200) {
    const { hasMore, nextOffset, results } = response.data;
    const { result, entities } = normalize(results, [groupSchema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        entities,
      })
    );
  }

  // TODO error catching
}
